import queryString from 'query-string';
import { SessionStorageKey } from '@constants';

export const checkBeforeRender = () => {
  const { userId } = queryString.parse(window.location.search);
  if (userId) {
    sessionStorage.setItem(SessionStorageKey.UserId, userId);
  }
};
